import { DateTime } from "luxon";

export const FORMS_EMAIL = "pictures@vsnmichigan.com";
const text=value=>String(value ?? "").trim();
const dateTime=value=>value instanceof Date ? DateTime.fromJSDate(value).setZone("America/New_York") : DateTime.fromISO(text(value),{zone:"America/New_York"}).setZone("America/New_York");
export function clientFormsEmail(appointment,userEmail="") {
  if(!appointment)throw new Error("Select an appointment first.");
  const date=dateTime(appointment.appointmentDate);
  const client=text(appointment.client) || "Unnamed client";
  const subject=`Forms request - ${client} - ${date.isValid ? date.toFormat("MM/dd/yyyy") : "Date not set"}`.replace(/[\r\n]/g," ");
  const lines=["Please send client forms for the following appointment.","",
    `Client: ${client}`,
    `Shoot date: ${date.isValid ? date.toFormat("cccc, MMMM d, yyyy") : "Not set"}`,
    ...(text(appointment.alternateShipTo) ? [] : [`Address: ${text(appointment.address) || "Not set"}`]),
    `Appointment contact: ${text(appointment.appointmentContacts) || "Not set"}`,"",
    "Order Form Notes:",text(appointment.orderFormNotes) || "No order form instructions entered."];
  if(text(appointment.summary))lines.push("","Summary:",text(appointment.summary));
  if(text(appointment.alternateShipTo))lines.push("","Ship to:",text(appointment.alternateShipTo));
  if(text(userEmail))lines.push("",`Requested by: ${text(userEmail)}`);
  const body=lines.join("\r\n");
  return {subject,body,href:`mailto:${FORMS_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`};
}
